module.exports = __webpack_public_path__ + "static/img/gold_bg5.9216356.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/gold_bg5.png
// module id = nA2t
// module chunks = 1